import { useState, useRef, useEffect } from 'react'

// local imports
import { IFilteredLactationRoomList, ILactationRoomFilteredReq } from 'types/LactationType'
import LactationService from 'service/LactationService'

export default function useGetLactationRoomList() {
  const [lactationRooms, setLactationRooms] = useState<IFilteredLactationRoomList[] | []>([])
  const [loading, setLoading] = useState(false)
  const isMountedRef = useRef(true)

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  /* Get Lactation Room List */
  const getLactationRoomList = (data: ILactationRoomFilteredReq) => {
    if (!isMountedRef.current) return
    setLoading(true)
    LactationService.getLactationRoomFilteredList(data)
      .then((r) => {
        if (isMountedRef.current) {
          setLactationRooms(r.data)
        }
      })
      .finally(() => {
        if (isMountedRef.current) {
          setLoading(false)
        }
      })
  }

  return { lactationRooms, getLactationRoomList, loading }
}
